module.exports = __webpack_public_path__ + "web-assets/img/count_bg.5938f705.png";